
import { defineComponent, ref } from 'vue'

export default defineComponent({
    props: {},
    setup(props, { emit }) {
        return {}
    },
})
